import http from '@/services/api/http';
import sessionVars from '@/helpers/sessionVars';

function bankRequestConfig(timeout, extra = {}) {
  return { timeout, ...extra };
}

export default {
  getBalance() {
    return http.get('api/User/Wallet/Balance');
  },
  getDepositCard() {
    const utmCodeParam = sessionVars.get('utm_code');
    if (utmCodeParam) {
      return http.get(`api/User/Wallet/DepositCard?${utmCodeParam.name}=${encodeURIComponent(utmCodeParam.value)}`);
    }
    return http.get('api/User/Wallet/DepositCard');
  },
  postConfirmDepositCard(payload) {
    const marketingPayload = sessionVars.payload(
      payload, 'utm_code', 'utm_campaign', 'utm_source');
    return http.post('api/User/Wallet/ConfirmDepositCard', marketingPayload);
  },
  postSubmitDepositCard(payload) {
    const marketingPayload = sessionVars.payload(
      payload, 'utm_code', 'utm_campaign', 'utm_source');
    return http.post('api/User/Wallet/SubmitDepositCard', marketingPayload);
  },
  getPayNearMe(page) {
    const utmCodeParam = sessionVars.get('utm_code');
    if (utmCodeParam) {
      return http.get(`api/User/Wallet/PayNearMe?page=${page}&${utmCodeParam.name}=${encodeURIComponent(utmCodeParam.value)}`);
    }
    return http.get(`api/User/Wallet/PayNearMe?page=${page}`);
  },
  getDepositUSDCoin() {
    const utmCodeParam = sessionVars.get('utm_code');
    if (utmCodeParam) {
      return http.get(`api/User/Wallet/DepositUSDCoin?${utmCodeParam.name}=${encodeURIComponent(utmCodeParam.value)}`);
    }
    return http.get('api/User/Wallet/DepositUSDCoin');
  },
  postSubmitDepositUSDCoin(payload) {
    const marketingPayload = sessionVars.payload(
      payload, 'utm_code', 'utm_campaign', 'utm_source');
    return http.post('api/User/Wallet/DepositUSDCoin', marketingPayload);
  },
  getWithdrawAch() {
    return http.get('api/User/Wallet/WithdrawAch');
  },
  getWithdrawCheck() {
    return http.get('api/User/Wallet/WithdrawCheck');
  },
  getWithdrawUSDC() {
    return http.get('api/User/Wallet/WithdrawUSDC');
  },
  postWithdrawAch(payload) {
    return http.post('api/User/Wallet/WithdrawAch', payload);
  },
  postWithdrawCheck(payload) {
    return http.post('api/User/Wallet/WithdrawCheck', payload);
  },
  postWithdrawUSDC(payload) {
    return http.post('api/User/Wallet/WithdrawUSDC', payload);
  },
  getPendingWithdrawals() {
    return http.get('api/User/Wallet/PendingWithdrawals');
  },
  getPendingDeposits() {
    return http.get('api/User/Wallet/PendingDeposits');
  },
  postCancelWithdrawal(payload) {
    return http.post('api/User/Wallet/CancelWithdrawal', payload);
  },
  getDepositMethods() {
    return http.get('api/User/Wallet/DepositMethods');
  },
  getWithdrawalMethods() {
    return http.get('api/User/Wallet/WithdrawalMethods');
  },
  getWithdrawWire() {
    return http.get('api/User/Wallet/WithdrawWire');
  },
  getWithdrawWireBankSearch(page, query) {
    return http.get(`api/User/Wallet/WithdrawWireBankSearch?page=${page}&query=${encodeURIComponent(query)}`);
  },
  postWithdrawWireBankInfo(payload) {
    return http.post('api/User/Wallet/WithdrawWireBankInfo', payload);
  },
  postWithdrawWireConfirm(payload) {
    return http.post('api/User/Wallet/WithdrawWireConfirm', payload);
  },
  postWithdrawWireSubmit(payload) {
    return http.post('api/User/Wallet/WithdrawWireSubmit', payload);
  },
  getDepositPWMB({ authorizationId, returnUrl, cancelUrl }) {
    const utmCodeParam = sessionVars.get('utm_code');
    if (utmCodeParam) {
      return http.get(`api/User/Wallet/DepositPWMB?AuthorizationIdToRefresh=${authorizationId}&requestedReturnUrl=${returnUrl}&requestedCancelUrl=${cancelUrl}&${utmCodeParam.name}=${encodeURIComponent(utmCodeParam.value)}`);
    }
    return http.get(`api/User/Wallet/DepositPWMB?AuthorizationIdToRefresh=${authorizationId}&requestedReturnUrl=${returnUrl}&requestedCancelUrl=${cancelUrl}`);
  },
  deletePWMBAuthorization(authorizationId) {
    return http.delete(`api/User/Wallet/PWMBAuthorization/${authorizationId}`);
  },
  postConfirmDepositPWMB(payload) {
    const marketingPayload = sessionVars.payload(
      payload, 'utm_code', 'utm_campaign', 'utm_source');
    return http.post('api/User/Wallet/ConfirmDepositPWMB', marketingPayload);
  },
  postSubmitDepositPWMB(payload) {
    const marketingPayload = sessionVars.payload(
      payload, 'utm_code', 'utm_campaign', 'utm_source');
    return http.post('api/User/Wallet/DepositPWMB', marketingPayload);
  },
  getPWMBAuthorization() {
    const queryPart = decodeURIComponent(window.location.search.replace('?pwmbDeposit=success&', '').replace('?pwmbDeposit=cancel&', ''));
    return http.get(`api/User/Wallet/PWMBAuthorization?redirectQueryStringPWMBPart=${queryPart}`);
  },
  postInstantCredit(payload) {
    return http.post('api/User/Wallet/InstantCredit', payload);
  },
  postBankLinkCreateSession(payload) {
    return http.post('api/User/Wallet/BankLinks/CreateSession', payload || {}, bankRequestConfig(35000));
  },
  postBankLinkStartProviderConfirmation(payload) {
    return http.post(
      'api/User/Wallet/BankLinks/StartProviderConfirmation',
      payload,
      bankRequestConfig(35000),
    );
  },
  postBankLinkConfirmProviderUser(payload) {
    return http.post(
      'api/User/Wallet/BankLinks/ConfirmProviderUser',
      payload,
      bankRequestConfig(35000),
    );
  },
  postBankLinkCreateReconnectSession(payload) {
    return http.post('api/User/Wallet/BankLinks/CreateReconnectSession', payload, bankRequestConfig(35000));
  },
  postBankLinkComplete(payload) {
    return http.post('api/User/Wallet/BankLinks/Complete', payload, bankRequestConfig(35000));
  },
  postBankLinkCompletionStatus(payload) {
    return http.post('api/User/Wallet/BankLinks/CompletionStatus', payload, bankRequestConfig(5000));
  },
  postBankLinkDiagnostic(payload) {
    return http.post('api/User/Wallet/BankLinks/Diagnostics', payload,
      bankRequestConfig(2000, { bankDiagnostic: true }));
  },
  getLinkedBankAccounts(config) {
    const utmCodeParam = sessionVars.get('utm_code');
    const requestConfig = utmCodeParam
      ? {
        ...(config || {}),
        params: {
          ...((config && config.params) || {}),
          [utmCodeParam.name]: utmCodeParam.value,
        },
      }
      : config;
    return http.get('api/User/Wallet/BankLinks/Accounts', bankRequestConfig(
      (config && config.timeout) || 10000, requestConfig,
    ));
  },
  postRemoveLinkedBankAccount(payload) {
    return http.post('api/User/Wallet/BankLinks/RemoveAccount', payload, bankRequestConfig(15000));
  },
  postDepositBankTransferForm(payload) {
    const marketingPayload = sessionVars.payload(
      payload, 'utm_code', 'utm_campaign', 'utm_source');
    return http.post('api/User/Wallet/DepositBankTransferForm', marketingPayload,
      bankRequestConfig(15000));
  },
  postConfirmDepositBankTransfer(payload) {
    const marketingPayload = sessionVars.payload(
      payload, 'utm_code', 'utm_campaign', 'utm_source');
    return http.post('api/User/Wallet/ConfirmDepositBankTransfer', marketingPayload,
      bankRequestConfig(35000));
  },
  postDepositBankTransfer(payload) {
    const marketingPayload = sessionVars.payload(
      payload, 'utm_code', 'utm_campaign', 'utm_source');
    return http.post('api/User/Wallet/DepositBankTransfer', marketingPayload, bankRequestConfig(45000));
  },
  postDepositBankTransferStatus(payload) {
    return http.post('api/User/Wallet/DepositBankTransferStatus', payload, bankRequestConfig(10000));
  },
};



// WEBPACK FOOTER //
// ./src/services/api/wallet.js